import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _venueEvents = [];

let VenueEventStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _venueEvents.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _venueEvents.find(function(e) { return e !== undefined && e.id == id; });
    },
    getByVenue: function(venueId) {
        return _venueEvents.filter(function(e) { return e !== undefined && e.venueId == venueId; });
    },
    add: function(entity) {
        if (entity !== undefined && !!entity.id && !!entity.venueId) {
            let index = _venueEvents.findIndex(function(e) { return e !== undefined && e.id == entity.id});
            if (0 <= index) {
                _venueEvents[index] = entity;
            } else {
                _venueEvents.push(entity);
            }
        }
    },
    remove: (startDate, endDate) => {
        _venueEvents = _venueEvents.filter((e) => (e.timeEnd < startDate || endDate < e.timeStart));
    }

});

VenueEventStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.VENUE_EVENT_LIST:
            VenueEventStore.remove(action.payload.data.startDate, action.payload.data.endDate);
            action.data.forEach(VenueEventStore.add);
            VenueEventStore.emitChange();
            break;

        case ActionTypes.VENUE_EVENT_LIST_ERROR:
            VenueEventStore.emitChange();
            break;

        default:
            break;

    }

});

export default VenueEventStore;
